function applyAttributes(listItems, attributeList, inserting) {
    if (!listItems || listItems.length === 0) {
        return null;
    }
    listItems.forEach(item => {
        attributeList.forEach(attribute => {
            const { name, setter } = attribute;
            const object = item.constructorList.find(obj => obj.field === name);
            if (inserting && object && !object.argument && attribute.defaultValue) {
                setter(attribute.defaultValue);
            }
            else if (object && setter) {
                setter(object.argument);
            }
        });
    });
}

export default { applyAttributes };
